module.exports = __webpack_public_path__ + "img/iotjximg.12e39a80.png";